import { DashboardLayout } from '../../components/DashboardLayout';
import EmptyState from '../../components/EmptyState';

const SupportPage = () => (
  <DashboardLayout>
    <EmptyState />
  </DashboardLayout>
);
export default SupportPage;
